import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27c39034&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=27c39034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c39034",
  null
  
)

/* custom blocks */
import block0 from "./langs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fworkspace%2Fsource-code%2Fpages%2Fconsignment%2Fexplain%2Fguide%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports